import { useEffect, useState } from "react";
import { GoogleSpreadsheet, GoogleSpreadsheetRow } from "google-spreadsheet";

const SPREADSHEET_ID = process.env.REACT_APP_SPREADSHEET_ID || "";
const SHEET_ID_EXPEDIENTES = process.env.REACT_APP_SHEET_ID_EXPEDIENTES || "";
const SHEET_ID_SEGUIMIENTO = process.env.REACT_APP_SHEET_ID_SEGUIMIENTO || "";
const CLIENT_EMAIL = process.env.REACT_APP_GOOGLE_CLIENT_EMAIL || "";
const PRIVATE_KEY = process.env.REACT_APP_GOOGLE_SERVICE_PRIVATE_KEY || "";

const doc = new GoogleSpreadsheet(SPREADSHEET_ID);
let doc_status = "INIT";

const connectToGoogleSheets = async () => {
	return new Promise(async (resolve, reject) => {
		try {
			await doc
				.useServiceAccountAuth({
					client_email: CLIENT_EMAIL,
					private_key: PRIVATE_KEY,
				})
				.catch((reason) => console.log(reason));
			await doc.loadInfo().catch((reason) => console.log(reason));
			doc_status = "CONNECTED";
			resolve(doc_status);
		} catch (e) {
			console.error("Error: ", e);
			reject(e);
		}
	});
};

const newSheetRecord = async (sheet_id: string, row_data: any): Promise<GoogleSpreadsheetRow> => {
	if (doc_status === "INIT") {
		await connectToGoogleSheets();
	}

	if (doc_status === "CONNECTED") {
		return doc.sheetsById[sheet_id].addRow(row_data);
	} else {
		return new Promise((resolve, reject) => reject);
	}
};

const getSheetRows = async (sheet_id: string): Promise<GoogleSpreadsheetRow[]> => {
	if (doc_status === "INIT") {
		await connectToGoogleSheets();
	}

	if (doc_status === "CONNECTED") {
		return doc.sheetsById[sheet_id].getRows();
	} else {
		return new Promise((resolve, reject) => reject);
	}
};

export type ExpedientesRow = { EXPEDIENTE: string; ENTIDAD_EMISORA: string; CLIENTE: string; MATERIA: string };

export const getExpedients = async () => {
	return new Promise<ExpedientesRow[]>((resolve, reject) => {
		getSheetRows(SHEET_ID_EXPEDIENTES)
			.then((rows) => {
				const rowsData = rows.map((row) => {
					return (row as unknown) as ExpedientesRow;
				});
				resolve(rowsData);
			})
			.catch(reject);
	});
};

export const newExpedient = async (data: ExpedientesRow) => {
	return newSheetRecord(SHEET_ID_EXPEDIENTES, data);
};

export type MateriaPenal = "CIVIL" | "FAMILIAR" | "MERCANTIL";

export type AcuerdosRow = {
	EXPEDIENTE: string;
	FECHA: string;
	JUZGADO: string;
	CLIENTE: string;
	SECRETARIA: string;
	ACUERDO: string;
	COMENTARIOS: string;
	MATERIA: MateriaPenal;
};

export const getAgreements = async () => {
	return new Promise<AcuerdosRow[]>((resolve, reject) => {
		getSheetRows(SHEET_ID_SEGUIMIENTO)
			.then((rows) => {
				const rowsData = rows.map((row) => {
					return (row as unknown) as AcuerdosRow;
				});
				resolve(rowsData);
			})
			.catch(reject);
	});
};

export const newAgreement = async (data: AcuerdosRow) => {
	return newSheetRecord(SHEET_ID_SEGUIMIENTO, data);
};

export const useAgreements = () => {
	const [agreementsData, setAgreementsData] = useState<AcuerdosRow[]>([]);
	const [fetch, setFetch] = useState<boolean>(false);

	useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await getAgreements();
				console.log("useAgreements fetch google data");
				setAgreementsData(data);
				setFetch(true);
			} catch (error) {
				alert(`Lo sentimos algo salio mal, contacta a Ramón y mensiona: \n ${error}`);
			}
		};

		if (!fetch) fetchData();
	}, [fetch]);

	return {
		getAgreements: () => agreementsData,
		fetch: () => {
			setFetch(false);
			setAgreementsData([]);
		},
		isReady: () => fetch,
	};
};
